import React, { useContext } from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import Header from "../../components/shared/Header/Header"
import { FeedSpinner } from "../../components/shared/Spinner"
import { RequestError } from "../../components/shared/RequestError"
import { RecentShows } from "./RecentShows"
import { Performers } from "./Performers"
import { Followers } from "./Followers"
import { UserInteractions } from "./UserInteractions"
import { Payouts } from "./Payouts"
import { MailerTemplates } from "./MailerTemplates"
import DashboardNav from "./DashboardNav"
import style from "../../components/shared/PageStyle.module.css"
import { useBand } from "../../hooks/useBand"
import { UserContext } from "../../components/HomeApp"
import Footer from "../../components/shared/Footer/Footer"

interface BandDashboardPageProps {
  bandId: number
}

export const BandDashboardPage: React.FC<BandDashboardPageProps> = ({ bandId }) => {
  const { user } = useContext(UserContext)
  const bandData = useBand(bandId, null, "")
  const band = bandData?.data?.band

  return (
    <div className={style.rootElStyle}>
      <Header user={user} />
      <div className="grid grid-cols-12 w-full pb-2 px-4">
        {bandData.status === "loading" ? (
          <FeedSpinner />
        ) : bandData.status === "error" ? (
          <RequestError error={bandData.error} />
        ) : (
          <div className="col-span-12">
            <h1 className="border-b-4 mt-4 border-black font-bold mb-4 text-3xl uppercase">
              Dashboard
            </h1>
            <DashboardNav />
            {band && (
              <Switch>
                <Route path="/dashboard/events" exact>
                  <RecentShows bandId={band.id} />
                </Route>
                <Route path="/dashboard/bands" exact>
                  <Performers bandId={band.id} />
                </Route>
                <Route path="/dashboard/followers" exact>
                  <Followers bandId={band.id} />
                </Route>
                <Route path="/dashboard/stats" exact>
                  <UserInteractions bandId={band.id} />
                </Route>
                <Route path="/dashboard/payouts" exact>
                  <Payouts bandId={band.id} payeeId={band.payee_id} />
                </Route>
                <Route path="/dashboard/mailer_templates" exact>
                  <MailerTemplates bandId={band.id} />
                </Route>
                <Redirect to="/dashboard/events" />
              </Switch>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  )
}

export default BandDashboardPage
